import React from 'react';
import Tooltip from '../../tooltip/Tooltip';
import CustomerSummary from '../CustomerSummary';
import ShortGuestsSummary from '../ShortGuestsSummary';
import { stayStatusMapping } from '../StayStatusIcon';

const ReservationCalendarTitle = ({ reservation }) => {
  const statusInfo = stayStatusMapping[reservation.stayStatus];
  const IconComponent = statusInfo?.icon;

  return (
    <div className="d-flex flex-wrap align-items-center gap-2">

      {IconComponent && (
        <Tooltip tooltip={statusInfo.label}>
          <div>
            <IconComponent />
          </div>
        </Tooltip>
      )}

      <span> {reservation.businessId}</span>

      <div className="d-flex flex-wrap align-items-center gap-2">

        <span> {reservation.houses[0].name}</span>
        <ShortGuestsSummary guests={reservation.guests} />
        <CustomerSummary customer={reservation.customer} />
      </div>
    </div>
  );
};

export default ReservationCalendarTitle;
